import { render, staticRenderFns } from "./lastEvalsItem.vue?vue&type=template&id=a835fb32&"
import script from "./lastEvalsItem.vue?vue&type=script&lang=js&"
export * from "./lastEvalsItem.vue?vue&type=script&lang=js&"
import style0 from "./lastEvalsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports